export default {
      id: "i-service-blog-usage",
      viewBox: "0 0 158 136",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-blog",
      toString: function () {
        return this.url;
      }
    }